import {
  useEffect,
  useState,
  useMemo,
} from 'react';
import format from 'string-template';

import { firestorePaths, pathPlaceholder } from '../../utils/paths';
import User from '../../Model/User';
import useComponentMounted from '../../hooks/useComponentMounted';

const useUserDoc = (userId, { viewAsCoachId } = {}) => {
  const [userDoc, setUserDoc] = useState(null);

  const isComponentMountedRef = useComponentMounted();

  useEffect(() => {
    const initUserDoc = async () => {
      // Coach-scoped surfaces must pin the coach whose relationship they render;
      // without it the model falls back to resolvePrimaryCoachId, which refuses
      // to guess (returns undefined) for multi-coach clients.
      const newUserDoc = new User(format(firestorePaths.USER_DOC, {
        [pathPlaceholder.USER_ID]: userId,
      }), { viewAsCoachId });

      await newUserDoc.init();

      if (isComponentMountedRef.current) {
        setUserDoc(newUserDoc);
      }
    };

    // Re-init on a changed pin: the same mounted screen can switch relationship, and
    // a stale pin renders the other coach's per-coach state.
    if (userId && (!userDoc || userDoc.viewAsCoachId !== viewAsCoachId)) {
      initUserDoc();
    }
  }, [
    userDoc,
    isComponentMountedRef,
    userId,
    viewAsCoachId,
  ]);

  return useMemo(() => ({
    isReady: !!userDoc,
    userDoc,
  }), [
    userDoc,
  ]);
};

export default useUserDoc;
